import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import { logError } from 'commons/logger';
import { getInsightsUserToken } from './insightsObjectDataUtils';

const handleProductClick = (algoliaMetaData = {}) => {
  const objectID = algoliaMetaData?.objectID;
  const queryID = algoliaMetaData?.queryID;

  const objectIDStr = objectID != null ? String(objectID).trim() : '';
  const queryIDStr = queryID != null ? String(queryID).trim() : '';
  const isValidObjectID = objectIDStr.length > 0;
  const isValidQueryID = queryIDStr.length > 0;

  if (!isValidObjectID || !isValidQueryID) return;

  const objectIDs = [objectIDStr];

  if (window.aa && window.algoliaInitialized) {
    window.aa('clickedObjectIDsAfterSearch', {
      eventName: 'Product Clicked',
      userToken: getInsightsUserToken(),
      // Must match the index that produced `queryID`, which on a sorted listing
      // is a replica rather than the primary index.
      index: algoliaMetaData?.indexName || ALGOLIA_INDEX_NAME.PRODUCTS,
      objectIDs,
      positions: [algoliaMetaData?.position ?? 0],
      queryID: queryIDStr,
    });
  } else {
    logError('Algolia Insights not initialized yet.');
  }
};

export default handleProductClick;
